<template>
  <div>
    <FieldsetBox>
      <template #header v-if="showHeader">
        <div style="width: 30%; margin: -2em auto auto auto; background: #fff;">
          <SVGPlaneClouds />
        </div>
      </template>
      <template #content>
        <div class="is-size-7">
          <div class="has-text-weight-bold">
            <span class="has-text-weight-bold is-size-6">{{
              getPrice($store.state.bookTravel.result) | formatPriceFromDollars
            }}</span>
          </div>
          <div v-if="fareDescription !== ''" class="has-text-weight-bold">
            Fare class:
            <span class="has-text-grey has-text-weight-normal">{{
              fareDescription
            }}</span>
          </div>
        </div>
        <div v-if="traveler" class="is-size-7 has-text-weight-bold">
          Passenger:
          <span class="has-text-grey has-text-weight-semibold"
            >{{ traveler.firstName }} {{ traveler.lastName }}</span
          >
        </div>
        <SmallFlightItinerary
          v-for="(leg, index) in segments"
          :leg="leg"
          :flight="flight"
          :key="index"
          :journeys="segments"
          class="my-3"
        />

        <hr />
        <div v-for="(guest, idx) in guests" :key="guest.profile.id">
          <div class="columns is-mobile">
            <div class="column">
              <div class="is-size-7">
                <div class="has-text-weight-bold">
                  <span class="has-text-weight-bold is-size-6">{{
                    getPrice(guest.result) | formatPriceFromDollars
                  }}</span>
                </div>
                <div v-if="getFareDescription(guest.result) !== ''" class="has-text-weight-bold">
                  Fare class:
                  <span class="has-text-grey has-text-weight-normal">{{ getFareDescription(guest.result) }}</span>
                </div>
              </div>

              <div class="is-size-7 has-text-weight-bold mb-2">
                Passenger:
                <span class="has-text-grey has-text-weight-semibold"
                  >{{ guest.profile.firstName }}
                  {{ guest.profile.lastName }}</span
                >
              </div>
            </div>

            <div class="column is-narrow">
              <b-tooltip
                label="Delete this passenger from itinerary"
                position="is-left"
                type="is-primary"
              >
                <div @click="deleteGuest(idx)" class="is-clickable">
                  <b-icon
                    size="is-small"
                    type="is-primary"
                    icon="delete"
                    class="ml-1"
                    inverted
                  />
                </div>
              </b-tooltip>
            </div>
          </div>

          <SmallFlightItinerary
            v-for="(leg, index) in guest.result.flight.journeys"
            :key="index + 100"
            :leg="leg"
            :flight="guest.result.flight"
            :journeys="guest.result.flight.journeys"
            :guestIndex="guests.indexOf(guest)"
            class="mb-3"
          />
          <hr />
        </div>

        <div class="columns is-mobile is-centered">
          <div class="column is-narrow">
            <b-button
              v-if="canAddGuest"
              size="is-small"
              icon-left="account"
              @click="addGuestModal"
            >
              Add guest passenger
            </b-button>
          </div>
        </div>
      </template>
      <template #footer>
        <b-button
          size="is-small"
          type="normal"
          @click="checkDelete()"
          icon-right="delete"
          inverted
          class="ml-1"
        />
        <b-button
          size="is-small"
          type="normal"
          @click="checkOk()"
          icon-right="pencil"
          inverted
          class="ml-1"
        />
      </template>
    </FieldsetBox>
  </div>
</template>

<script>
import SmallFlightItinerary from "./SmallFlightItinerary.vue";
import SVGPlaneClouds from "../SVGs/SVG-PlaneClouds";
import FieldsetBox from "../UI/FieldsetBox";
import bookingMixin from "../../mixins/bookingMixin";
//import SeatMapMenu from '../SeatMap/SeatMapMenu.vue';
import AddMeetingGuest from "@/components/Meetings/AddMeetingGuest.vue";
import meetingsMixin from "@/mixins/meetingsMixin";

export default {
  name: "ItineraryFlight",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    SmallFlightItinerary,
    SVGPlaneClouds,
    FieldsetBox,
  },
  props: {
    traveler: Object,
    flight: Object,
    guests: Array,
    multiLeg: Boolean,
    segments: [Object, Array],
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      display_full: false,
    };
  },
  computed: {
    canAddGuest() {
      return this.pathMixin_isMeeting && this.meetingInfo.allowedToBringGuest;
    },
    totalPrice() {
      return this.flight?.pricing.total;
    },
    fareDescription() {
      if (this.selectedOffer?.journeyList) {
        return this.selectedOffer.journeyList[0].bookingClass;
      }
      return this.flight?.fareFamily?.familyDescription;
    },
    selectedOffer() {
      return this.$store.state.bookTravel.result.selectedOffer;
    },
  },
  methods: {
    ok() {
      this.$nav.pushRouteTo({ name: "BookingFlights" });
    },
    getFareDescription(result) {
      if (result.selectedOffer) {
        return result.selectedOffer.journeyList[0].bookingClass;
      }
      return result.flight?.fareFamily?.familyDescription;
    },
    getPrice(result) {
      return result.flight?.pricing.total;
    },
    checkDelete() {
      if (this.multiLeg) {
        this.$buefy.dialog.confirm({
          message:
            "This flight is part of a multi-flight trip. Deleting it will delete all flights in this itinerary.",
          confirmText: "Delete",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.del(),
        });
      } else {
        this.$buefy.dialog.confirm({
          message:
            "Are you sure you would like to delete this flight from your itinerary?",
          confirmText: "Delete",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.del(),
        });
      }
    },
    checkOk() {
      if (this.multiLeg) {
        this.$buefy.dialog.confirm({
          message:
            "This flight is part of a multi-flight trip. Editing it will delete all flights in this itinerary.",
          confirmText: "Edit",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.ok(),
        });
      } else {
        this.ok();
      }
    },
    del() {
      this.$store.commit("bookTravel/ALTER_FLIGHT_RESULT", {});
      this.$store.commit("bookTravel/DELETE_ALL_GUESTS");
      this.clearBundledSelections();
    },
    deleteGuest(index) {
      this.$store.commit("bookTravel/DEL_GUEST_TRIP", index);
    },
    addGuestModal() {
      this.$buefy.modal.open({
        parent: this,
        component: AddMeetingGuest,
        props: {},
        hasModalCard: true,
        trapFocus: true,
        width: 650,
      });
    },
  },
};
</script>

<style scoped></style>
